import React from 'react';

const StatsSection: React.FC = () => {
  return (
    <section className="py-16 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Transforming workplace wellness worldwide
          </h2>
          <h3 className="text-xl md:text-2xl text-gray-600 dark:text-gray-300">
            The impact of employee wellness initiatives
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {/* Stat 1 */}
          <div className="text-center p-8 bg-gradient-to-br from-purple-50 to-white dark:from-slate-800 dark:to-slate-900 rounded-xl shadow-lg">
            <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              38%
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-lg leading-relaxed">
              of team members feel more energized and committed, with sick days dropping by 28% when organizations implement structured wellness initiatives, based on industry research.
            </p>
          </div>

          {/* Stat 2 */}
          <div className="text-center p-8 bg-gradient-to-br from-purple-50 to-white dark:from-slate-800 dark:to-slate-900 rounded-xl shadow-lg">
            <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              $1
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-lg leading-relaxed">
              return on investment: healthcare expenses drop by roughly $3.45 per dollar invested, while productivity losses from absences decrease by approximately $2.85, as shown in comprehensive workplace wellness studies.
            </p>
          </div>

          {/* Stat 3 */}
          <div className="text-center p-8 bg-gradient-to-br from-purple-50 to-white dark:from-slate-800 dark:to-slate-900 rounded-xl shadow-lg">
            <div className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
              42%
            </div>
            <p className="text-gray-700 dark:text-gray-300 text-lg leading-relaxed">
              boost in daily movement was achieved across more than 6,200 participants in a corporate wellness program powered by Fitzaa.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;

